import { LabelValueSet } from "../utility/LabelValueSet";

const BathAtHomeType = Symbol();

export class BathAtHome extends LabelValueSet  {
    [BathAtHomeType]: any;

    static default(): BathAtHome {
        return あり;
    }
}

const なし = new BathAtHome("なし", "false");
const あり = new BathAtHome("あり", "true");

export const BathAtHomeList: BathAtHome[] = [
    あり,
    なし,
];

export const getBathAtHomeFromValue = (value: boolean): BathAtHome => {
    return value ? あり : なし;
};

export type BathAtHomeJson = {
    bathAtHome: boolean
};

export const BathAtHomeInitialState = {
    bathAtHome: true
};
